// extracted by mini-css-extract-plugin
module.exports = {"tocoTable":"table_tocoTable__A85Op","noRows":"table_noRows__27s4G","labelNoToC":"table_labelNoToC__1uKGC"};